export default __webpack_public_path__ + "static/media/hingo-screenshot-01.420b38c4.png";